import { forwardRef, useEffect, useState } from "react";

// ** MUI Imports
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Select from "@mui/material/Select";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import CardContent from "@mui/material/CardContent";
import Fade from "@mui/material/Fade";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import FileUploaderMultiple from "../../../FileUpload/FileUploaderMultiple";
import CloseIcon from "@mui/icons-material/Close";

import { CircularProgress, Divider, FormHelperText } from "@mui/material";
import { createSvgIcon } from "@mui/material/utils";
import FileUploaderMultiMedia, {
  SLIDE_MULTI_MEDIA_MAX_FILE_SIZE,
} from "../../../FileUpload/FileUploaderMultiMedia";
import { getAppConfig } from "../../../../redux/Configuration/configurationSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const initialFormData = {
  type: "",
  description: "",
  background_colors: [],
  background_directions: "",
  foreground_structure: "",
  actiontrigger: "",
  orientation: "",
  foreground_texts: [{ text: "", color: "#b76262", style: "normal", size: 12 }],
  background_image: "",
  foreground_images: [],
  createdAt: Date.now(),
  updatedAt: Date.now(),
  enabled: false,
};

const Transition = forwardRef(function Transition(props, ref) {
  return <Fade ref={ref} {...props} />;
});

const PlusIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 4.5v15m7.5-7.5h-15"
    />
  </svg>,
  "Plus",
);

const CreateSlide = ({
  show,
  setShow,
  addressType,
  setAddressType,
  selectedStructure,
  setSelectedStructure,
  carouselstructure,
  corousel_type,
  carouselorientation,
  carouseldirection,
  slidestyles,
  onClose,
  onSubmit,
  formData,
  setFormData,
  fieldErrors,
  setFieldErrors,
  loading,
  setLoading,
}) => {
  const activeIndex = 0;
  const [color, setColor] = useState("#ff0000");
  const [backgroundColors, setBackgroundColors] = useState([]);
  const [gradientColor, setGradientColor] = useState("#ff0000");
  const [carouselMultimediaStatus, setCarouselMultimediaStatus] =
    useState(false);
  const dispatch = useDispatch();
  const configData = useSelector((state) => state.appConfig.configData);
  useEffect(() => {
    if (show) {
      dispatch(getAppConfig());
    }
  }, [show, dispatch]);
  useEffect(() => {
    if (Object.keys(configData).length) {
      setCarouselMultimediaStatus(
        configData?.featureToggle?.carousel_multimedia === true,
      );
    }
  }, [configData]);

  useEffect(() => {
    if (show && formData.foreground_structure) {
      setSelectedStructure(formData.foreground_structure);
    }
  }, [show, formData.foreground_structure]);

  const handleFileChange = (files) => {
    const newFiles = Array.isArray(files) ? files : [files];

    setFormData((prev) => ({
      ...prev,
      foreground_images: [...(prev.foreground_images || []), ...newFiles],
    }));
  };

  const handleAddColor = () => {
    setBackgroundColors((prev) => {
      if (!prev.includes(color)) {
        return [...prev, color];
      }
      return prev;
    });

    setFormData((prev) => {
      const updatedTexts = [...prev.foreground_texts];
      if (!updatedTexts[0]) {
        updatedTexts[0] = { text: "", style: "normal", size: 12 };
      }
      updatedTexts[0] = {
        ...updatedTexts[0],
        color,
      };
      return {
        ...prev,
        foreground_texts: updatedTexts,
      };
    });
  };

  const addGradientColor = () => {
    setFormData((prev) => ({
      ...prev,
      background_colors: [...(prev.background_colors || []), gradientColor],
    }));
  };

  return (
    <>
      <Dialog
        fullWidth
        open={show}
        scroll="body"
        onClose={() => {
          setShow(false);
          setFormData(initialFormData);
        }}
        TransitionComponent={Transition}
        onBackdropClick={() => setShow(true)}
      >
        <Box>
          <IconButton
            size="small"
            onClick={() => {
              setShow(false);
              setFormData(initialFormData);
            }}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              cursor: "pointer",
              background: "#E2E2EA",
              borderRadius: "50%",
              width: 26,
              height: 26,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#646464",
            }}
          >
            <CloseIcon />
          </IconButton>

          <Typography
            fontWeight={700}
            fontSize={24}
            p={2}
            sx={{
              background: "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
              color: "#fff",
            }}
          >
            Create Slide
          </Typography>
          <Box sx={{ p: 2 }}>
            <Grid
              container
              spacing={6}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Grid
                    container
                    spacing={3}
                    sx={{ display: "flex", flexDirection: "column" }}
                  >
                    <Grid item xs={12}>
                      <FormControl
                        fullWidth
                        size="small"
                        error={Boolean(fieldErrors?.foreground_structure)}
                      >
                        <InputLabel id="select-structure-1">
                          Select Structure
                        </InputLabel>
                        <Select
                          fullWidth
                          label="Position"
                          labelId="select-structure-1"
                          value={selectedStructure}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              value === "multi_media" &&
                              !carouselMultimediaStatus
                            ) {
                              toast.info(
                                "This feature is not enabled for your account.\nPlease contact the administrator.",
                              );
                              return;
                            }
                            setSelectedStructure(value);
                            setFormData((prev) => ({
                              ...prev,
                              foreground_structure: value,
                            }));
                            if (fieldErrors?.foreground_structure) {
                              fieldErrors.foreground_structure = "";
                            }
                          }}
                        >
                          <MenuItem value="">Select structure</MenuItem>
                          {carouselstructure.map((str, index) => (
                            <MenuItem key={index} value={str}>
                              {str}
                            </MenuItem>
                          ))}
                        </Select>
                        {fieldErrors?.foreground_structure && (
                          <FormHelperText>
                            {fieldErrors.foreground_structure}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Enter carousel text"
                        placeholder="carousel text"
                        size="small"
                        value={formData.foreground_texts[0]?.text || ""}
                        onChange={(e) => {
                          const updated = [...formData.foreground_texts];
                          const newObj = {
                            ...updated[0],
                            text: e.target.value,
                          };
                          updated[0] = newObj;
                          setFormData((prev) => ({
                            ...prev,
                            foreground_texts: updated,
                          }));
                        }}
                        disabled={["images", "multi_media"].includes(
                          selectedStructure,
                        )}
                      />
                    </Grid>
                    {selectedStructure !== "images" ? (
                      <Grid item xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="select-style-1">
                            Select Style
                          </InputLabel>
                          <Select
                            fullWidth
                            label="Select Style"
                            labelId="select-style-1"
                            value={formData.foreground_texts[0]?.style || ""}
                            onChange={(e) => {
                              const updated = [...formData.foreground_texts];
                              if (!updated[0]) updated[0] = {};
                              updated[0].style = e.target.value;
                              setFormData((prev) => ({
                                ...prev,
                                foreground_texts: updated,
                              }));
                            }}
                            size="small"
                          >
                            {slidestyles.map((style, index) => (
                              <MenuItem key={index} value={style}>
                                {style}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    ) : undefined}
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Enter carousel size"
                        placeholder="Size"
                        size="small"
                        type="number"
                        value={formData.foreground_texts[0]?.size || ""}
                        onChange={(e) => {
                          const updated = [...formData.foreground_texts];
                          if (!updated[0]) updated[0] = {};
                          updated[0].size = parseInt(e.target.value);
                          setFormData((prev) => ({
                            ...prev,
                            foreground_texts: updated,
                          }));
                        }}
                        disabled={["images", "multi_media"].includes(
                          selectedStructure,
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label htmlFor="backgroundColor">
                        Select Carousel Text Color:
                      </label>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <input
                          type="color"
                          id="backgroundColor"
                          value={color}
                          onChange={(e) => setColor(e.target.value)}
                          style={{
                            width: 40,
                            height: 40,
                            border: "none",
                            background: "none",
                          }}
                          disabled={["images", "multi_media"].includes(
                            selectedStructure,
                          )}
                        />
                        <IconButton
                          color="primary"
                          onClick={handleAddColor}
                          disabled={["images", "multi_media"].includes(
                            selectedStructure,
                          )}
                        >
                          <PlusIcon />
                        </IconButton>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 1,
                          mt: 1,
                        }}
                      >
                        {backgroundColors.map((clr, index) => (
                          <Box
                            key={index}
                            sx={{
                              width: 24,
                              height: 24,
                              backgroundColor: clr,
                              borderRadius: "50%",
                              border: "1px solid #ccc",
                              position: "relative",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              if (selectedStructure === "images") return;
                              const updatedTexts = [
                                ...formData.foreground_texts,
                              ];
                              if (!updatedTexts[0]) {
                                updatedTexts[0] = {
                                  text: "",
                                  style: "normal",
                                  size: 12,
                                };
                              }

                              updatedTexts[0] = {
                                ...updatedTexts[0],
                                color: clr,
                              };

                              setFormData((prev) => ({
                                ...prev,
                                foreground_texts: updatedTexts,
                              }));
                            }}
                          >
                            {/* Optional remove button */}
                            <Box
                              onClick={(e) => {
                                e.stopPropagation();
                                setBackgroundColors((prev) =>
                                  prev.filter((c, i) => i !== index),
                                );
                              }}
                              sx={{
                                position: "absolute",
                                top: -6,
                                right: -6,
                                backgroundColor: "#fff",
                                border: "1px solid #ccc",
                                borderRadius: "50%",
                                width: 14,
                                height: 14,
                                fontSize: 10,
                                lineHeight: "14px",
                                textAlign: "center",
                                cursor: "pointer",
                              }}
                            >
                              ×
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                {selectedStructure !== "texts" &&
                selectedStructure !== "multi_media" ? (
                  <FileUploaderMultiple
                    value={formData.foreground_images}
                    accept="image/*,video/*"
                    multiple
                    onChange={handleFileChange}
                    onRemove={(index) =>
                      setFormData((prev) => ({
                        ...prev,
                        foreground_images: prev.foreground_images.filter(
                          (_, i) => i !== index,
                        ),
                      }))
                    }
                  />
                ) : undefined}
                {selectedStructure === "multi_media" && (
                  <FileUploaderMultiMedia
                    value={formData.foreground_images}
                    maxFileSize={SLIDE_MULTI_MEDIA_MAX_FILE_SIZE}
                    onChange={(files) =>
                      setFormData((prev) => ({
                        ...prev,
                        foreground_images: files,
                      }))
                    }
                  />
                )}
              </Grid>
              <Divider textAlign="left" sx={{ margin: 2 }}></Divider>
            </Grid>
            <Grid item xs={12} md={4} sx={{ mt: 1, width: "60%" }}>
              <TextField
                fullWidth
                multiline
                id="textarea-outlined"
                placeholder="Description"
                label="Description"
                size="small"
                //error={Boolean(fieldErrors?.description)}
                value={formData.description || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
                // helperText={fieldErrors?.description || 'Enter a short description'}
              />
            </Grid>
            <Divider textAlign="left" sx={{ marginTop: 2 }}></Divider>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth size="small">
                  <InputLabel id="type-select-1">Select Type</InputLabel>
                  <Select
                    fullWidth
                    label="Select Type"
                    sx={{ minWidth: "250px" }}
                    labelId="type-select-1"
                    value={formData.type || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        type: e.target.value,
                      }))
                    }
                  >
                    <MenuItem value="">Select Type</MenuItem>
                    {corousel_type.map((ct, index) => (
                      <MenuItem key={index} value={ct}>
                        {ct}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} sx={{ minWidth: "250px" }}>
                {formData.type === "route" ? (
                  <FormControl
                    fullWidth
                    size="small"
                    error={Boolean(fieldErrors.actiontrigger)}
                  >
                    <InputLabel id="route-select-label">
                      Select Route
                    </InputLabel>
                    <Select
                      labelId="route-select-label"
                      label="Select Route"
                      value={formData.actiontrigger || ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          actiontrigger: e.target.value,
                        }))
                      }
                    >
                      <MenuItem value="">Select Position</MenuItem>
                      <MenuItem value="sip">SIP</MenuItem>
                      <MenuItem value="sell">Sell</MenuItem>
                      <MenuItem value="redeem">Redeem</MenuItem>
                      <MenuItem value="gift">Gift</MenuItem>
                      <MenuItem value="lookbook">Lookbook</MenuItem>
                      <MenuItem value="refer">Refer</MenuItem>
                    </Select>

                    {fieldErrors.actiontrigger && (
                      <FormHelperText>
                        {fieldErrors.actiontrigger}
                      </FormHelperText>
                    )}
                  </FormControl>
                ) : ["whatsapp", "call", "sms"].includes(formData.type) &&
                  ![
                    "images",
                    "multi_media",
                    "texts",
                    "text_image",
                    "image_text",
                  ].includes(selectedStructure) ? (
                  <Grid container spacing={1}>
                    <Grid item xs={4} sx={{ display: "flex" }}>
                      <TextField
                        select
                        sx={{ width: "150px" }}
                        size="small"
                        label="Code"
                        value={formData.countryCode || "+91"}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            countryCode: e.target.value,
                          }))
                        }
                      >
                        <MenuItem value="+91">🇮🇳 +91</MenuItem>
                        <MenuItem value="+1">🇺🇸 +1</MenuItem>
                        <MenuItem value="+44">🇬🇧 +44</MenuItem>
                        <MenuItem value="+971">🇦🇪 +971</MenuItem>
                      </TextField>

                      <TextField
                        fullWidth
                        label="Phone Number"
                        size="small"
                        value={formData.phoneNumber || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            phoneNumber: e.target.value,
                          }))
                        }
                        error={Boolean(fieldErrors.actiontrigger)}
                        helperText={fieldErrors.actiontrigger}
                      />
                    </Grid>
                  </Grid>
                ) : (
                  <TextField
                    fullWidth
                    multiline
                    placeholder="Action on"
                    label="Carousel Action"
                    size="small"
                    value={formData.actiontrigger || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        actiontrigger: e.target.value,
                      }))
                    }
                    error={Boolean(fieldErrors.actiontrigger)}
                    helperText={fieldErrors.actiontrigger}
                  />
                )}
              </Grid>
            </Grid>
            <Divider textAlign="left" sx={{ marginTop: 2 }}></Divider>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth size="small">
                  <InputLabel id="gradient-irection-1">
                    Select Gradient Direction
                  </InputLabel>
                  <Select
                    fullWidth
                    label="Select Gradient Direction"
                    labelId="gradient-irection-1"
                    sx={{ minWidth: "250px" }}
                    value={formData.background_directions || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        background_directions: e.target.value,
                      }))
                    }
                  >
                    {carouseldirection.map((cld, index) => (
                      <MenuItem key={index} value={cld}>
                        {cld === "LR" ? "Left to Right" : "Top to Bottom"}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth size="small">
                  <InputLabel id="select-slide-orientation-1">
                    Select Slide Orientation
                  </InputLabel>
                  <Select
                    fullWidth
                    label="Orientation"
                    labelId="select-slide-orientation-1"
                    value={formData.orientation || ""}
                    sx={{ minWidth: "250px" }}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        orientation: e.target.value,
                      }))
                    }
                  >
                    {carouselorientation.map((ori, index) => (
                      <MenuItem key={index} value={ori}>
                        {ori === "LR" ? "Left to Right" : "Top to Bottom"}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6} mt={2}>
              <label htmlFor="favcolor">Select gradient colors:</label>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <input
                  type="color"
                  id="favcolor"
                  name="favcolor"
                  value={gradientColor}
                  onChange={(e) => setGradientColor(e.target.value)}
                  style={{
                    width: 40,
                    height: 40,
                    border: "none",
                    background: "none",
                  }}
                />
                <span onClick={addGradientColor} style={{ cursor: "pointer" }}>
                  <PlusIcon />
                </span>
              </Box>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                {formData.background_colors?.map((clr, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: 24,
                      height: 24,
                      backgroundColor: clr,
                      borderRadius: "50%",
                      border: "1px solid #ccc",
                      position: "relative",
                      cursor: "pointer",
                    }}
                  >
                    <Box
                      onClick={(e) => {
                        e.stopPropagation();
                        setFormData((prev) => ({
                          ...prev,
                          background_colors: prev.background_colors.filter(
                            (c, i) => i !== index,
                          ),
                        }));
                      }}
                      sx={{
                        position: "absolute",
                        top: -6,
                        right: -6,
                        backgroundColor: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "50%",
                        width: 14,
                        height: 14,
                        fontSize: 10,
                        lineHeight: "14px",
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                    >
                      ×
                    </Box>
                  </Box>
                ))}
              </Box>
            </Grid>
          </Box>
          <DialogActions
            sx={{
              justifyContent: "end",
            }}
          >
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                setShow(false);
                setFormData(initialFormData);
              }}
              size="small"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                textTransform: "none",
                background:
                  "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
                fontFamily: "inherit",
              }}
              onClick={() => {
                const errors = {};

                // ✅ Check structure
                if (!selectedStructure) {
                  errors.foreground_structure = "Structure is required";
                }

                // ✅ Validate type-specific actiontrigger
                // if (!formData.type) {
                //   errors.type = "Type is required";
                // } else {
                //   switch (formData.type) {
                //     case "call":
                //     case "whatsapp":
                //     case "sms":
                //       if (!formData.actiontrigger) {
                //         errors.actiontrigger = "Phone number is required";
                //       } else if (
                //         !/^\+?[1-9]\d{7,14}$/.test(formData.actiontrigger)
                //       ) {
                //         errors.actiontrigger =
                //           "Enter a valid international phone number";
                //       }
                //       break;

                //     case "email":
                //       if (!formData.actiontrigger) {
                //         errors.actiontrigger = "Email is required";
                //       } else if (!/\S+@\S+\.\S+/.test(formData.actiontrigger)) {
                //         errors.actiontrigger = "Enter a valid email address";
                //       }
                //       break;

                //     case "ext_url":
                //     case "int_url":
                //     case "youtube":
                //       if (!formData.actiontrigger) {
                //         errors.actiontrigger = "URL is required";
                //       } else {
                //         try {
                //           new URL(formData.actiontrigger);
                //         } catch {
                //           errors.actiontrigger =
                //             "Enter a valid URL (https://...)";
                //         }
                //       }
                //       break;

                //     case "route":
                //       if (!formData.actiontrigger) {
                //         errors.actiontrigger = "Route is required";
                //       }
                //       break;

                //     default:
                //       break;
                //   }
                // }

                // ✅ Stop if errors found
                if (Object.keys(errors).length > 0) {
                  setFieldErrors(errors);
                  return;
                }

                // ✅ Clear errors and submit
                setFieldErrors({});
                setLoading(true);
                onSubmit(formData);
              }}
              size="small"
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "Submit"
              )}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};

export default CreateSlide;
